import { PageTitle } from "@/lib/mui/PageTitle";
import { getPrivacyPolicyHtml } from "@/modules/static/getPrivacyPolicyHtml";
import { getWebsiteLayout } from "@/modules/navigation/website-layout/WebsiteLayout";
import Head from "next/head";
import { appConfig } from "../config/app-config";
import { NextPageWithLayout } from "./_app";
import { PageLayout } from "@/modules/navigation/website-layout/PageLayout";

const Page: NextPageWithLayout<{ html: string }> = ({ html }) => {
  return (
    <>
      <Head>
        <title>Privacy Policy – {appConfig.name}</title>
      </Head>

      <PageLayout>
        <PageTitle>Privacy Policy</PageTitle>
        <article>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </article>
      </PageLayout>
    </>
  );
};

export async function getServerSideProps() {
  return {
    props: { html: await getPrivacyPolicyHtml() },
  };
}

Page.getLayout = getWebsiteLayout;

export default Page;
